import { getLanguage } from "../../../utils/utils";

// Copy for the V2 report pages.
//
// Kept separate from the translations in ReportBase.js, which are shared with
// V1 - these strings only exist in the V2 layout. Keys that V1 already
// translates (overallResult, benchmarkAnalysis, highlights, ...) are read from
// `this.state.messages` instead of being duplicated here.
const v2Translations = {
  hr: {
    index: "Index",
    indexItems: [
      { id: "page-about", label: "O certifikatu Employer Partner" },
      { id: "page-overall", label: "Ukupni rezultat" },
      { id: "page-overall-benchmark", label: "Ukupni rezultat - Benchmark" },
      { id: "page-key-topics", label: "Rezultati na ključnim temama" },
      {
        id: "page-key-topics-benchmark",
        label: "Rezultati na ključnim temama - Benchmark",
      },
      { id: "page-elc", label: "Rezultati na employee life cycle koracima" },
      {
        id: "page-elc-benchmark",
        label: "Rezultati na employee life cycle koracima - Benchmark",
      },
      {
        id: "page-highlights",
        label: "7 koraka employee life cycle modela - snage i sugestije",
      },
      {
        id: "page-practices-strengths",
        label: "Vaše HR prakse u brojevima - snage",
      },
      {
        id: "page-practices-suggestions",
        label: "Vaše HR prakse u brojevima - sugestije",
      },
      {
        id: "page-practices-benchmark",
        label: "Vaše HR prakse u brojevima - benchmark",
      },
      {
        id: "page-educations",
        label: "Razvojne aktivnosti koje bi vam mogle biti korisne",
      },
      { id: "page-confirmation", label: "Autorizacija" },
      { id: "page-whats-next", label: "Što je sljedeće" },
      { id: "page-timeline", label: "Timeline" },
    ],
    aboutEyebrow: "O certifikatu Employer Partner",
    whatsInIt: "Što dobivate?",
    whatsInItIntro:
      "Employer Partner certifikat jedino je nepristrano priznanje poznatih stručnjaka europske HR zajednice za izvrsnost u upravljanju ljudskim potencijalima koje potvrđuje:",
    whatsInItList: [
      "Kvalitetu HR procesa",
      "Usklađenost HR-a i poslovnih ciljeva",
      "Spremnost za buduće izazove",
    ],
    whatsInItOutro:
      "Finalni izvještaj donosi strukturirani pregled upravljanja ljudskim potencijalima u vašoj organizaciji te prilagođene preporuke za njegov daljnji razvoj.",
    stats: [
      { value: "20+", label: "godina iskustva" },
      { value: "200+", label: "evaluiranih organizacija" },
      { value: "200K", label: "zaposlenika u certificiranim tvrtkama" },
    ],

    scoringTitle: "Razumijevanje<br/>metodologije bodovanja",
    scoringIntro:
      "Kako bi postala Employer Partner, organizacija mora ostvariti {threshold}% ukupnog rezultata kroz 30 HR tema, uz zadovoljavanje praga kvalitete na 10 ključnih tema:",
    confidentialityTitle: "Obavijest o povjerljivosti",
    confidentialityText:
      "Ovaj Finalni izvještaj namijenjen je isključivo internoj upotrebi Klijenta. Niti jedan njegov dio ne smije se prosljeđivati, citirati ili reproducirati za distribuciju trećim stranama bez prethodnog pisanog odobrenja tvrtke Selectio Solutions d.o.o.",

    perspectives: "Dvije perspektive. Jedna cjelina.",
    employeePerspective: "perspektiva zaposlenika",
    businessPerspective: "HR & poslovna perspektiva",

    // Browser tab / PDF filename. Matches the cover wording.
    pageTitle: "Employer Partner - Finalni izvještaj",
    coverTitle: "Employer Partner Finalni izvještaj",
    coverResultsFor: "Rezultati za:",
    statusLabel: "Status",
    statusCertified: "Certificiran",
    statusNotCertified: "Nije certificiran",
    yearLabel: "Godina",

    yourResults: "Vaši rezultati",
    yourResultsIntro:
      "U nastavku donosimo vaš ukupni rezultat kao i glavne rezultate koje ste postigli u odnosu na prosjek rezultata koje ostvaruju druge organizacije.",
    turningInsights: "Preporuke i sljedeći koraci",
    turningInsightsIntro:
      "Vaši su rezultati polazišna točka za dalje. Donosimo vam prijedloge za unaprjeđenje praksi upravljanja ljudskim potencijalima prilagođene upravo vama i detaljan benchmark koji će vas usmjeriti u pravom smjeru.",

    keyTopicsTitle: "Rezultati po<br/>ključnim temama",
    elcSteps: "Rezultati po koracima Employee Life Cyclea",
    practices: "Vaše HR prakse u brojevima",
    practicesStrengths: "Vaša briga za zaposlenike u brojevima",
    keepInMind: "Razmislite o povećanju ovih KPI-eva",

    developmentActivities: "Razvojne aktivnosti koje vam mogu biti korisne",
    forEmployees: "ZA ZAPOSLENIKE",
    forManagers: "ZA MENADŽERE",
    developmentActivitiesIntro:
      "Prema vašim potrebama predlažemo sljedeće razvojne aktivnosti:",

    servicesTitle:
      "Kamo god vas vaš HR put dalje vodio, tu smo sa stručnošću i podrškom koja vam je potrebna.",
    servicesIntro:
      "SELECTIO već više od dva desetljeća razvija komplementarna HR rješenja za vodeće kompanije u regiji, povezujući ekspertizu, razumijevanje tržišta i podršku prilagođenu stvarnim potrebama klijenata.",
    servicesOutro:
      "Birate podršku koja vam treba danas, uz partnera koji može podržati i ono što dolazi sutra.",
    servicesUrl: "https://selectio.hr/",
    servicesCta: "Istražite naše usluge",
    services: [
      {
        title: "Zapošljavanje",
        text: "Pronalazimo i povezujemo organizacije s talentima kroz selekciju, executive search, outsourcing i fleksibilne modele prilagođene poslovnim ciljevima.",
      },
      {
        title: "Assesment",
        text: "Kroz testiranja, 360° procjene, DNLA i assessment centre pružamo objektivan uvid u potencijal, sposobnosti i razvojne potrebe zaposlenika i kandidata.",
      },
      {
        title: "HR savjetovanje",
        text: "Pomažemo u razvoju HR procesa, provodimo ispitivanja angažiranosti i prepoznajemo organizacije koje se ističu na tržištu.",
      },
      {
        title: "Edukacije i razvoj",
        text: "Kreiramo edukacije, treninge i razvojne programe za timove, menadžere i HR u naprednim formatima koji mjere razvoj i garantiraju promjenu.",
      },
    ],

    officialConfirmation: "Autorizacija",
    officialConfirmationText: [
      "Klijent je obvezan proučiti ovaj izvještaj te potvrditi da sve navedeno odražava trenutno stanje upravljanja ljudskim potencijalima u njegovoj organizaciji.",
      "Klijent je dužan obavijestiti Certifikacijski tim o svim netočnim, nejasnim ili izostavljenim informacijama, kao i o svim relevantnim promjenama nastalima nakon dostave informacija.",
      "Certifikacijski tim potvrđuje da su procesi Klijenta ocijenjeni u skladu sa standardima definiranima u Knjizi standarda.",
      "Certifikat izdaje SELECTIO Group.",
    ],

    visibility: "Promocija employer branda",
    visibilityIntro:
      "Vaša organizacija zadržava pravo korištenja statusa Employer Partner do {date} godine, nakon čega se treba ponovno prijaviti za proces certifikacije kako bi zadržala status.",
    visibilityDatePlaceholder: "datum",
    visibilityOutro:
      "Nakon postizanja standarda u procesu certificiranja, mi ćemo:",
    visibilitySteps: [
      {
        title: "Dodjela certifikata i PR aktivacija",
        text: "Kontaktirat ćemo vas vezano za medijsku objavu i dostaviti vam oznaku Employer Partner te ključne PR materijale.",
      },
      {
        title: "Profil tvrtke na našoj web stranici",
        text: "Promovirat ćemo vašu organizaciju regionalnoj poslovnoj zajednici te istaknuti vaša postignuća i najnoviji certifikat.",
      },
      {
        title: "Aktivacija oznake na MojPosao",
        text: "Certifikat će biti prikazan na vašim oglasima za posao objavljenim na platformi MojPosao, radi veće vidljivosti i povjerenja kandidata.",
      },
      {
        title: "PR članak u Lideru i drugim medijima",
        text: "Objavit ćemo PR članak u partnerskim medijima i dijeliti vaše postignuće s relevantnom poslovnom publikom i kandidatima.",
      },
      {
        title: "Blog ili intervju s HR-om/CEO-om",
        text: "Blog objava ili intervju prikazat će vaš pristup upravljanju ljudskim potencijalima i istaknuti HR inicijative na koje ste ponosni.",
      },
      {
        title: "Objava vijesti na našem LinkedInu",
        text: "Vaše priznanje bit će objavljeno na našem LinkedInu, gdje objave dosežu između 2.000 i 7.000 korisnika, a najviše ih čita C-level.",
      },
    ],

    timeline: "Vremenski okvir",
    timelineIntro: "Razdoblja u kojima možete planirati svoj angažman:",
    timelineSteps: [
      "Dodjela i PR aktivnosti",
      "Dostava računa",
      "Popunjavanje upitnika",
      "Recertifikacija",
    ],
    months: {
      july: "Srpanj",
      december: "Prosinac",
      marchApril: "Ožujak - Travanj",
      june: "Lipanj",
    },

    outroTitle: "Čestitamo!<br/>Vrijeme je da podijelite<br/>svoj uspjeh.",
    // Offered in the picker on the development activities slide. The
    // certifier can choose one or type their own text.
    developmentOptions: [
      "selekcijski intervju",
      "osiguravanje jednakih mogućnosti",
      "osobni razvojni planovi",
      "osobni razvojni planovi – novi menadžeri",
      "train the trainer",
      "vještine mentoriranja",
      "coaching",
      "ključni HR procesi",
      "ključni HR procesi – novi menadžeri",
      "vještine upravljanja ljudima",
      "vještine upravljanja ljudima – novi menadžeri",
      "komunikacijske vještine",
      "komunikacijske vještine – novi menadžeri",
      "vještine davanja povratne informacije",
      "upravljanje radnim učinkom",
      "upravljanje radnim učinkom – novi menadžeri",
      "motiviranje zaposlenika",
      "upravljanje promjenama",
      "upravljanje promjenama – novi menadžeri",
      "reskilling & upskilling",
      "izrada karijernih planova",
      "izrada karijernih planova – novi menadžeri",
      "upravljanje talentima",
      "upravljanje talentima – novi menadžeri",
      "sustav nagrađivanja",
      "sustav nagrađivanja – novi menadžeri",
      "osobna otpornost i prevencija burnouta",
      "razvoj timske kohezije",
      "upravljanje stresom i balans privatnog i poslovnog",
      "prevencija diskriminacije i mobbinga",
      "poticanje DEI",
      "potrebe i mogućnosti osoba s invaliditetom",
      "outplacement",
      "HR kompetencije",
      "poznavanje businessa",
    ],
    addCard: "+ Dodaj karticu",
    addStep: "+ Dodaj korak",
    partnerLabel: "Partneri projekta:",
    outroWebsite: "employerpartner.eu",
  },

  en: {
    index: "Index",
    indexItems: [
      { id: "page-about", label: "About Employer Partner" },
      { id: "page-overall", label: "Overall result" },
      { id: "page-overall-benchmark", label: "Overall result - Benchmark" },
      { id: "page-key-topics", label: "Results on the key topics" },
      {
        id: "page-key-topics-benchmark",
        label: "Results on the key topics - Benchmark",
      },
      { id: "page-elc", label: "Results on the Employee Life Cycle steps" },
      {
        id: "page-elc-benchmark",
        label: "Results on the Employee Life Cycle steps - Benchmark",
      },
      {
        id: "page-highlights",
        label: "7 steps of Employee Life Cycle - Highlights & Suggestions",
      },
      {
        id: "page-practices-strengths",
        label: "Your HR practices in numbers - Highlights",
      },
      {
        id: "page-practices-suggestions",
        label: "Your HR practices in numbers - Suggestions",
      },
      {
        id: "page-practices-benchmark",
        label: "Your HR practices in numbers - Benchmark",
      },
      {
        id: "page-educations",
        label: "Educations that we find useful for you",
      },
      { id: "page-confirmation", label: "Official confirmation" },
      { id: "page-whats-next", label: "What's next" },
      { id: "page-timeline", label: "Timeline" },
    ],
    aboutEyebrow: "About Employer Partner",
    whatsInIt: "What's in it for you",
    whatsInItIntro:
      "Employer Partner is the only impartial recognition from leading European HR experts for excellence in Human Resource Management that confirms:",
    whatsInItList: [
      "Quality of HR processes",
      "Alignment of HR and business objectives",
      "Readiness for future challenges",
    ],
    whatsInItOutro:
      "The Final Report provides a structured overview of your organisation's HR management, with tailored recommendations for further development.",
    stats: [
      { value: "20+", label: "years of experience" },
      { value: "200+", label: "evaluated organizations" },
      { value: "200K", label: "employees in certified companies" },
    ],

    scoringTitle: "Understanding the<br/>Scoring Methodology",
    scoringIntro:
      "To become an Employer Partner, the organization must achieve {threshold}% overall score across 30 HR topics, while meeting the quality threshold on 10 key topics:",
    confidentialityTitle: "Confidentiality Notice",
    confidentialityText:
      "This Report is for the Client's internal use only. No part may be shared, copied, photographed, reproduced, or distributed to third parties.",

    perspectives: "Bringing two perspectives into one picture",
    employeePerspective: "employee perspective",
    businessPerspective: "HR & business perspective",

    // Browser tab / PDF filename. Matches the cover wording.
    pageTitle: "Employer Partner - Final report",
    coverTitle: "Employer Partner Final Report",
    coverResultsFor: "Results for:",
    statusLabel: "Status",
    statusCertified: "Certified",
    statusNotCertified: "Not certified",
    yearLabel: "Year",

    yourResults: "Your results",
    yourResultsIntro:
      "We present your overall result as well as the main results you have achieved in relation to the average results achieved by other organizations.",
    turningInsights: "Turning Insights into Action",
    turningInsightsIntro:
      "Your results are the starting point. Based on our findings and benchmark insights, we provide tailored recommendations to help you strengthen HR practices, focus on the areas that matter most, and guide your next steps.",

    keyTopicsTitle: "Results on the<br/>key topics",
    elcSteps: "Results on the Employee Life Cycle steps",
    practices: "Your HR practices in numbers",
    practicesStrengths: "Your care for employees in numbers",
    keepInMind: "Keep in mind to increase these KPIs",

    developmentActivities: "Development activities that we find useful for you",
    forEmployees: "FOR EMPLOYEES",
    forManagers: "FOR MANAGERS",
    developmentActivitiesIntro:
      "According to your needs, we selected activities that we find useful for your growth:",

    servicesTitle:
      "Wherever your HR journey takes you next, we're here with the expertise and support you need to go forward.",
    servicesIntro:
      "For over two decades, SELECTIO has been developing tailored HR solutions for leading companies across the region, combining expertise, market insight and a client-focused approach.",
    servicesOutro:
      "You choose the support you need today, with a partner who can also support what comes tomorrow.",
    servicesUrl: "https://selectio.hr/en",
    servicesCta: "Explore our services",
    services: [
      {
        title: "Hiring",
        text: "We connect organisations with talent through recruitment, executive search, outsourcing and flexible models tailored to business objectives.",
      },
      {
        title: "Assesment",
        text: "Through testing, 360°, DNLA and assessment centres, we provide objective insight into the potential, capabilities and development needs.",
      },
      {
        title: "HR Consulting",
        text: "We support the development of HR processes, conduct employee engagement surveys and recognise organisations that stand out.",
      },
      {
        title: "Educations",
        text: "We create learning, training and development programmes for teams, managers and HR, using advanced formats that measure development and ensure change.",
      },
    ],

    officialConfirmation: "Official confirmation",
    officialConfirmationText: [
      "The Client is obligated to review the Final Report and confirm that it accurately reflects the current state of human resources management within the company.",
      "The Client shall inform the Certification Team of any inaccurate, unclear, or omitted information, as well as any relevant changes that occurred after the information was provided.",
      "The Certification Team confirms that the Client's processes were assessed in accordance with the standards defined in the Book of Standards.",
      "The certificate is issued by SELECTIO Group.",
    ],

    visibility: "Employer Brand Visibility & Recognition",
    visibilityIntro:
      "Your organization retains the right to use the Employer Partner status until {date}, before which it should reapply for the certification process in order to keep the status.",
    visibilityDatePlaceholder: "date",
    visibilityOutro:
      "After reaching the standard in the certification process, you can expect:",
    visibilitySteps: [
      {
        title: "Award ceremony and PR activation",
        text: "We will contact you about the media statement and provide the Employer Partner badge as well as key PR materials.",
      },
      {
        title: "Company profile on our website",
        text: "We will promote your organisation to the regional business community, highlighting your achievements and newest certification.",
      },
      {
        title: "Badge activation on Moj Posao job ads",
        text: "The certificate will be displayed on all your job postings published on the Moj Posao platform to increase visibility and candidates' trust.",
      },
      {
        title: "PR article in LIDER and other media",
        text: "We will publish a PR article on partner media sharing your story and achievement with a relevant business and candidate audience.",
      },
      {
        title: "Blog or Interview with your HR/CEO",
        text: "A blog post or interview will show your approach to HR management and will highlight the HR initiatives you're most proud of.",
      },
      {
        title: "Sharing the news via our LinkedIn",
        text: "Your recognition will be shared on our LinkedIn where posts reach between 2,000 and 7,000 users and are read mostly by c-level.",
      },
    ],

    timeline: "Timeline",
    timelineIntro: "Periods during which you can plan engagement on your side:",
    timelineSteps: [
      "Award and PR Activities",
      "Invoicing",
      "Completing the Questionnaire",
      "Recertification",
    ],
    months: {
      july: "July",
      december: "December",
      marchApril: "March - April",
      june: "June",
    },

    outroTitle:
      "Congratulations!<br/>It is time to share<br/>your success story",
    // Offered in the picker on the development activities slide. The
    // certifier can choose one or type their own text.
    developmentOptions: [
      "selection interviews",
      "ensuring equal opportunities",
      "IDP-s",
      "IDP-s – new managers",
      "train the trainer",
      "mentoring skills",
      "coaching",
      "key HR processes",
      "key HR processes - new managers",
      "people management",
      "people management - new managers",
      "communication skills",
      "communication skills - new managers",
      "feedback skills",
      "performance management",
      "performance management - new managers",
      "employee motivation",
      "change management",
      "change management - new managers",
      "reskilling & upskilling",
      "creating career development plans",
      "career development plans – new managers",
      "talent management",
      "talent management - new managers",
      "remuneration system",
      "remuneration system - new managers",
      "personal resilience & burnout prevention",
      "team cohesion development",
      "stress management & work-life balance",
      "discrimination and mobbing prevention",
      "fostering DEI",
      "needs and abilities of people with disabilities",
      "outplacement",
      "HR competencies",
      "business acumen",
    ],
    addCard: "+ Add card",
    addStep: "+ Add step",
    partnerLabel: "PARTNER:",
    outroWebsite: "employerpartner.eu",
  },

  sr: {
    index: "Index",
    indexItems: [
      { id: "page-about", label: "O sertifikatu Employer Partner" },
      { id: "page-overall", label: "Ukupni rezultat" },
      { id: "page-overall-benchmark", label: "Ukupni rezultat - Benchmark" },
      { id: "page-key-topics", label: "Rezultati po ključnim temama" },
      {
        id: "page-key-topics-benchmark",
        label: "Rezultati na ključnim temama - Benchmark",
      },
      { id: "page-elc", label: "Rezultati na employee life cycle koracima" },
      {
        id: "page-elc-benchmark",
        label: "Rezultati na employee life cycle koracima - Benchmark",
      },
      {
        id: "page-highlights",
        label: "7 koraka employee life cycle modela - snage i sugestije",
      },
      {
        id: "page-practices-strengths",
        label: "Vaše HR prakse u brojevima - snage",
      },
      {
        id: "page-practices-suggestions",
        label: "Vaše HR prakse u brojevima - sugestije",
      },
      {
        id: "page-practices-benchmark",
        label: "Vaše HR prakse u brojevima - benchmark",
      },
      {
        id: "page-educations",
        label: "Razvojne aktivnosti koje bi vam mogle biti korisne",
      },
      { id: "page-confirmation", label: "Autorizacija" },
      { id: "page-whats-next", label: "Šta je sledeće" },
      { id: "page-timeline", label: "Timeline" },
    ],
    aboutEyebrow: "O sertifikatu Employer Partner",
    whatsInIt: "Šta dobijate?",
    whatsInItIntro:
      "Employer Partner sertifikat je jedino nepristrasno priznanje poznatih stručnjaka evropske HR zajednice za izvrsnost u upravljanju ljudskim resursima koje potvrđuje:",
    whatsInItList: [
      "Kvalitet HR procesa",
      "Usklađenost HR-a i poslovnih ciljeva",
      "Spremnost za buduće izazove",
    ],
    whatsInItOutro:
      "Finalni izveštaj donosi strukturiran pregled upravljanja ljudskim resursima u vašoj organizaciji te prilagođene preporuke za njegov dalji razvoj.",
    stats: [
      { value: "20+", label: "godina iskustva" },
      { value: "200+", label: "evaluiranih organizacija" },
      { value: "200K", label: "zaposlenih u sertifikovanim kompanijama" },
    ],

    scoringTitle: "Razumevanje<br/>metodologije bodovanja",
    scoringIntro:
      "Da bi postala Employer Partner, organizacija mora ostvariti {threshold}% ukupnog rezultata kroz 30 HR tema, uz zadovoljavanje praga kvaliteta na 10 ključnih tema:",
    confidentialityTitle: "Obaveštenje o poverljivosti",
    confidentialityText:
      "Ovaj Finalni izveštaj namenjen je isključivo internoj upotrebi Klijenta. Nijedan njegov deo ne sme se prosleđivati, citirati ili reprodukovati za distribuciju trećim stranama bez prethodnog pisanog odobrenja kompanije Selectio Solutions d.o.o.",

    perspectives: "Dve perspektive. Jedna celina.",
    employeePerspective: "perspektiva zaposlenih",
    businessPerspective: "HR & poslovna perspektiva",

    // Browser tab / PDF filename. Matches the cover wording.
    pageTitle: "Employer Partner - Finalni izveštaj",
    coverTitle: "Employer Partner Finalni izveštaj",
    coverResultsFor: "Rezultati za:",
    statusLabel: "Status",
    statusCertified: "Sertifikovan",
    statusNotCertified: "Nije sertifikovan",
    yearLabel: "Godina",

    yourResults: "Vaši rezultati",
    yourResultsIntro:
      "U nastavku donosimo vaš ukupni rezultat kao i glavne rezultate koje ste postigli u odnosu na prosek rezultata koje ostvaruju druge organizacije.",
    turningInsights: "Preporuke i sledeći koraci",
    turningInsightsIntro:
      "Vaši su rezultati polazna tačka za dalje. Donosimo vam predloge za unapređenje praksi upravljanja ljudskim resursima prilagođene upravo vama i detaljan benchmark koji će vas usmeriti u pravom smeru.",

    keyTopicsTitle: "Rezultati po<br/>ključnim temama",
    elcSteps: "Rezultati po koracima Employee Life Cyclea",
    practices: "Vaše HR prakse u brojevima",
    practicesStrengths: "Vaša briga za zaposlenike u brojevima",
    keepInMind: "Razmislite o povećanju ovih KPI-eva",

    developmentActivities: "Razvojne aktivnosti koje vam mogu biti korisne",
    forEmployees: "ZA ZAPOSLENE",
    forManagers: "ZA MENADŽERE",
    developmentActivitiesIntro:
      "Prema vašim potrebama predlažemo sledeće razvojne aktivnosti:",

    servicesTitle:
      "Gde god vas vaš HR put dalje vodio, tu smo sa stručnošću i podrškom koja vam je potrebna.",
    servicesIntro:
      "SELECTIO već više od dve decenije razvija komplementarna HR rešenja za vodeće kompanije u regionu, povezujući ekspertizu, razumevanje tržišta i podršku prilagođenu stvarnim potrebama klijenata.",
    servicesOutro:
      "Birate podršku koja vam treba danas, uz partnera koji može podržati i ono što dolazi sutra.",
    servicesUrl: "https://selectio.hr/",
    servicesCta: "Istražite naše usluge",
    services: [
      {
        title: "Zapošljavanje",
        text: "Pronalazimo i povezujemo organizacije sa talentima kroz selekciju, executive search, outsourcing i fleksibilne modele prilagođene poslovnim ciljevima.",
      },
      {
        title: "Assesment",
        text: "Kroz testiranja, 360° procene, DNLA i assessment centre pružamo objektivan uvid u potencijal, sposobnosti i razvojne potrebe zaposlenih i kandidata.",
      },
      {
        title: "HR savetovanje",
        text: "Pomažemo u razvoju HR procesa, sprovodimo ispitivanja angažovanosti i prepoznajemo organizacije koje se ističu na tržištu.",
      },
      {
        title: "Edukacije i razvoj",
        text: "Kreiramo edukacije, treninge i razvojne programe za timove, menadžere i HR u naprednim formatima koji mere razvoj i garantuju promenu.",
      },
    ],

    officialConfirmation: "Autorizacija",
    officialConfirmationText: [
      "Klijent je obavezan da prouči ovaj izveštaj i potvrdi da sve navedeno odražava trenutno stanje upravljanja ljudskim resursima u njegovoj organizaciji.",
      "Klijent je dužan da obavesti Sertifikacioni tim o svim netačnim, nejasnim ili izostavljenim informacijama, kao i o svim relevantnim promenama nastalim nakon dostave informacija.",
      "Sertifikacioni tim potvrđuje da su procesi Klijenta ocenjeni u skladu sa standardima definisanim u Knjizi standarda.",
      "Sertifikat izdaje SELECTIO Group.",
    ],

    visibility: "Promocija employer branda",
    visibilityIntro:
      "Vaša organizacija zadržava pravo korištenja statusa Employer Partner do {date} godine, nakon čega se treba ponovno prijaviti za proces certifikacije kako bi zadržala status.",
    visibilityDatePlaceholder: "datum",
    visibilityOutro:
      "Nakon postizanja standarda u procesu sertifikacije, mi ćemo:",
    visibilitySteps: [
      {
        title: "Dodela sertifikata i PR aktivacija",
        text: "Kontaktiraćemo vas povodom medijske objave i dostaviti vam oznaku Employer Partner i ključne PR materijale.",
      },
      {
        title: "Profil kompanije na našem sajtu",
        text: "Promovisaćemo vašu organizaciju regionalnoj poslovnoj zajednici i istaći vaša postignuća i najnoviji sertifikat.",
      },
      {
        title: "Aktivacija oznake na MojPosao",
        text: "Sertifikat će biti prikazan na vašim oglasima za posao objavljenim na platformi MojPosao, radi veće vidljivosti i poverenja kandidata.",
      },
      {
        title: "PR članak u Lideru i drugim medijima",
        text: "Objavićemo PR članak u partnerskim medijima i deliti vaše postignuće sa relevantnom poslovnom publikom i kandidatima.",
      },
      {
        title: "Blog ili intervju sa HR-om/CEO-om",
        text: "Blog objava ili intervju prikazaće vaš pristup upravljanju ljudskim resursima i istaći HR inicijative na koje ste ponosni.",
      },
      {
        title: "Objava vesti na našem LinkedInu",
        text: "Vaše priznanje biće objavljeno na našem LinkedInu, gde objave dosežu između 2.000 i 7.000 korisnika, a najviše ih čita C-level.",
      },
    ],

    timeline: "Vremenski okvir",
    timelineIntro: "Periodi u kojima možete planirati svoj angažman:",
    timelineSteps: [
      "Dodela i PR aktivnosti",
      "Dostava računa",
      "Popunjavanje upitnika",
      "Resertifikacija",
    ],
    months: {
      july: "Jul",
      december: "Decembar",
      marchApril: "Mart - April",
      june: "Jun",
    },

    outroTitle: "Čestitamo!<br/>Vreme je da podelite<br/>svoj uspeh.",
    // Offered in the picker on the development activities slide. The
    // certifier can choose one or type their own text.
    developmentOptions: [
      "selekcijski intervju",
      "osiguravanje jednakih mogućnosti",
      "lični razvojni planovi",
      "lični razvojni planovi – novi menadžeri",
      "train the trainer",
      "veštine mentorstva",
      "coaching",
      "ključni HR procesi",
      "ključni HR procesi – novi menadžeri",
      "veštine upravljanja ljudima",
      "veštine upravljanja ljudima – novi menadžeri",
      "komunikacijske veštine",
      "komunikacijske veštine – novi menadžeri",
      "veštine davanja povratne informacije",
      "upravljanje radnim učinkom",
      "upravljanje radnim učinkom – novi menadžeri",
      "motivisanje zaposlenih",
      "upravljanje promenama",
      "upravljanje promenama – novi menadžeri",
      "reskilling & upskilling",
      "izrada karijernih planova",
      "izrada karijernih planova – novi menadžeri",
      "upravljanje talentima",
      "upravljanje talentima – novi menadžeri",
      "sistem nagrađivanja",
      "sistem nagrađivanja – novi menadžeri",
      "lična otpornost i prevencija burnouta",
      "razvoj timske kohezije",
      "upravljanje stresom i balans privatnog i poslovnog",
      "prevencija diskriminacije i mobinga",
      "podsticanje DEI",
      "potrebe i mogućnosti osoba sa invaliditetom",
      "outplacement",
      "HR kompetencije",
      "poznavanje biznisa",
    ],
    addCard: "+ Dodaj karticu",
    addStep: "+ Dodaj korak",
    partnerLabel: "Partneri projekta:",
    outroWebsite: "employerpartner.eu",
  },
};

// Contact block on the outro slide - the same in every language.
// `phone` is kept but no longer printed: the slide shows the company, address
// and email only.
export const contact = {
  company: "Selectio Solutions d.o.o.",
  address: "Strojarska cesta 20, Zagreb",
  email: "contact@employerpartner.eu",
  phone: "+385 1 6065 271",
};

export default v2Translations[getLanguage()] || v2Translations.en;
